import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassPerformanceAnalytics from "PerformanceAnalytics/routes/ClassPerformanceAnalytics";
import StudentPerformanceAnalytics from "PerformanceAnalytics/routes/StudentPerformanceAnalytics";

export default store => {
  return {
    path: ":learningCourseId",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(
          /* webpackChunkName: "learning-course-overview" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [
      ClassPerformanceAnalytics(store),
      StudentPerformanceAnalytics(store),
    ],
  };
};
